export default __webpack_public_path__ + "static/media/Montserrat-SemiBold-600.fa8441f3.ttf";